(() => {
  const initializedAttribute = 'data-okg-home-header-ready';
  const transparentClass = 'is-okg-home-header-solid';

  const init = () => {
    const header = document.querySelector('.okg-home-header');
    if (!header || header.hasAttribute(initializedAttribute)) return;

    header.setAttribute(initializedAttribute, 'true');

    const syncHeaderState = () => {
      const menuIsOpen = header.querySelector('header-menu > details[open]') !== null;
      header.classList.toggle(transparentClass, window.scrollY > 8 || menuIsOpen);
    };

    window.addEventListener('scroll', syncHeaderState, { passive: true });
    header.addEventListener(
      'toggle',
      (event) => {
        if (event.target.matches('details')) window.requestAnimationFrame(syncHeaderState);
      },
      true
    );

    syncHeaderState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
